import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'recompose';

import useContext from 'utils/useContext';

import EventTimeline from 'components/EventTimeline';

import buildEvents from './buildEvents';
import CaseStatusContext from '../CaseStatusContext';

export function CaseEventTimeline({
  createdAt: caseCreatedAt,
  isReadOnlyCase,
  status,
  statusHistory,
  validationStatus,
  permissions,
  isPermissionsBasedRole,
  ...passThroughProps
}) {
  const events = buildEvents({
    caseCreatedAt,
    isReadOnlyCase,
    status,
    statusHistory,
    validationStatus,
    permissions,
    isPermissionsBasedRole,
  });

  return (
    <EventTimeline
      events={events}
      modifiers="padScale_0"
      {...passThroughProps}
    />
  );
}

CaseEventTimeline.propTypes = {
  createdAt: PropTypes.string.isRequired,
  isReadOnlyCase: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  statusHistory: PropTypes.arrayOf(
    PropTypes.shape({
      changedAt: PropTypes.string,
      oldStatus: PropTypes.string,
      newStatus: PropTypes.string,
    }),
  ).isRequired,
  validationStatus: PropTypes.string.isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string),
  isPermissionsBasedRole: PropTypes.bool.isRequired,
};

CaseEventTimeline.defaultProps = {
  permissions: [],
};

export default compose(
  setDisplayName('CaseEventTimeline'),
  useContext(CaseStatusContext),
)(CaseEventTimeline);



// WEBPACK FOOTER //
// ./src/compositions/CaseStatus/CaseEventTimeline/index.js